import { Col, Container, Row } from 'react-bootstrap';
import { useContext } from 'react';
import { UserContext } from '../../App';
import { t } from 'i18next';

export default function Reports() {
    const { userProfile } = useContext(UserContext);

    return (
        <div className="dashboard-container">
            <Container>
                <Row>
                    <Col xs={12}>
                        <h1>
                            { t("Reports") }
                        </h1>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
